/**
 * This version of this util file uses the models defined in bb-debit. This will replace the current util
 * once have completely migrated to bb-debit
 */

import { Card, CardStatus, Customization } from "/src/protos/squareup/bbdebit/cardmanagement";
import { ExpiryDateFormatter } from "field-kit";
import { CardCustomization } from "/src/protos/squareup/bizbank/service";
import { getImageUriFromCardCustomization } from "/src/util/image-bytes-utils-v2";
import { FieldMask } from "/src/protos/google/protobuf/field_mask";

/**
 * Utilities to help parse Card
 */
export const getBusinessName = (card: Card): string =>
  card.fulfillment?.cardCustomization?.cardTexts?.find(
    (cardText) => cardText.type === Customization.CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME
  )?.text ?? "";

export const getCardholder = (card: Card): string =>
  card.fulfillment?.cardCustomization?.cardTexts?.find(
    (cardText) => cardText.type === Customization.CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME
  )?.text ?? "";

export const getCardSignatureUri = (cardCustomization?: CardCustomization): string => {
  if (cardCustomization) {
    return getImageUriFromCardCustomization(cardCustomization);
  }
  return "";
};

export const getCvc = (card: Card): string => {
  return card.securityCode || "";
};

export const getExpirationDateString = (card: Card): string => {
  const expiration = card.expirationData?.expiration;
  if (!expiration) return "";

  const formatter = new ExpiryDateFormatter();
  return formatter.format({
    month: expiration.monthOfYear,
    year: expiration.year,
  });
};

export const getFullPan = (card: Card): string => {
  return card.fullPan || "";
};

export const isActivatable = (card: Card): boolean =>
  card?.status === CardStatus.CARD_STATUS_ACTIVATABLE;

// List of fields to retrieve when fetching a Card from bbdebit.RetrieveCard
export const CARD_FIELD_MASK_LIST = FieldMask.create({
  paths: [
    "id",
    "status",
    "card_brand",
    "fulfillment",
    "last_four",
    "full_pan",
    "security_code",
    "can_digital_spend",
    "balance_id",
    "relationship",
    "expiration_data",
  ],
});
